import { render } from "./Content.vue?vue&type=template&id=eaddb6e6"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=eaddb6e6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layout/Content.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eaddb6e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eaddb6e6', __exports__)) {
    api.reload('eaddb6e6', __exports__)
  }
  
  module.hot.accept("./Content.vue?vue&type=template&id=eaddb6e6", () => {
    api.rerender('eaddb6e6', render)
  })

}


export default __exports__